import React, { useState, useRef } from 'react';
import { IoMdArrowDropdown } from 'react-icons/io';
import NavigationMenu from './NavigationMenu';
import PremiumServices from './premiumServices';
import { ComingSoonModal } from '../../ComingSoonModal/ComingSoonModal';
import useCustomNavigate from '../../../hooks/useCustomNavigate';

const SubNavBar = () => {

  const {goTo} = useCustomNavigate()


  const [hoveredItem, setHoveredItem] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const navRefs = useRef([]);  // Use an array of refs for each navigation item

  // Add or update a ref in an array
  const addToRefs = (el, index) => {
    if (el && !navRefs.current.includes(el)) {
      navRefs.current[index] = el;
    }
  };


  const BuyCategories = [
    {
      name: 'Property Types',
      items: ['Residential', 'Commercial', 'Industrial', 'Agricultural']
    },
    {
      name: 'Property Choices',
      items: ['Furnished Property', 'Unfurnished property', 'Under Construction', 'ready to move', 'owner property', 'Agent Property']
    },
    {
      name: 'Explore',
      items: ['Investment Ideas', 'Property valuation', 'Guidance']
    },
    {
      name: 'Budget',
      items: ['10 to 15 lakh', 'above 50 lakh', '7 crore', 'above 7 crore']
    },

    {
      name: 'New Projects',
      items: ['AD.. locality',]
    },
  ];

  const RentCategories = [
    {
      name: 'Property Types',
      items: ['Flats', 'Flat mate', "PG", 'Villa', 'House', 'Co-live Space', 'Office Space', "Commericial Space"]
    },
    {
      name: 'Popular Choices',
      items: ['Owner Properties', 'Agent Property', 'Verified', "Bachelors", "Available Now!!"]
    },
    {
      name: 'Budget',
      items: ['Under 9000', '9000 to 18000', '18000 to 24000', 'Above 24000']
    },
    {
      name: 'Services',
      items: ['Hire Agents', 'Property Services', 'Rent Agreement', 'Pay Rent', 'Rental furniture']
    },
  ];



  const SellCategories = [
    {
      name: '',
      items: [
        { name: "My Dashboard", url: "https://one-two-one-admin-panel.vercel.app" },
        { name: "Post Property", url: "/addproperty" },
      ]
    },
    {
      name: '',
      items: [
        { name: "Post New Projects", url: "/addproject" },
         "Advertisement packages"
        ]
    },
    {
      name: '',
      items: ["Plans"]
    },
  ];




  const PlansCategories = [
    {
      name: '',
      items: ["Silver", "Gold", "Platinum"]
    },
  ]


  const RelationManagementCategories = [
    {
      name: '',
      items: ['Hire a Manager']
    },
  ];

  const UseFullLinksCategories = [
    {
      name: "",
      items: [
        { name: "Apna Bazar", url: "https://apnabazarstores.com/" },
        { name: "Paisa Bazar", url: "https://www.paisabazaar.com/" },
        { name: "CERSAI", url: "https://www.cersai.org.in/CERSAI/home.prg" }
      ]
    }
  ]

  return (
    <>
      <div className="bg-[#2b463c] flex space-x-5 z-10 pl-10 items-center fixed text-white top-[72px] w-full">
        {['Buy', 'Rent', 'Sell', 'Relation Management', 'Premium Services', 'Plans',"Usefull Links"].map((item, index) => (
          <div
            key={index}
            ref={(el) => addToRefs(el, index)}  // Add ref to each item
            className="flex items-center p-2 hover:text-gray-300 cursor-pointer justify-center relative"
            onMouseEnter={() => setHoveredItem(item)}
            onMouseLeave={() => setHoveredItem('')}
          >
            <span className='text-[16px]'>{item}</span>
            <IoMdArrowDropdown />
          </div>
        ))}
      </div>
      {hoveredItem === 'Buy' && navRefs.current[0] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[0].getBoundingClientRect().bottom,
            left: navRefs.current[0].getBoundingClientRect().left  // Position submenu under "Buy"
          }}
          onMouseEnter={() => setHoveredItem('Buy')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu categories={BuyCategories} parentCategory="Sell" />
        </div>
      )}
      {hoveredItem === 'Rent' && navRefs.current[1] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[1].getBoundingClientRect().bottom,
            left: navRefs.current[1].getBoundingClientRect().left  // Position submenu under "Buy"
          }}
          onMouseEnter={() => setHoveredItem('Rent')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu categories={RentCategories} parentCategory="Rent"/>
        </div>
      )}
      {hoveredItem === 'Sell' && navRefs.current[2] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[2].getBoundingClientRect().bottom,
            left: navRefs.current[2].getBoundingClientRect().left  // Position submenu under "Buy"
          }}
          onMouseEnter={() => setHoveredItem('Sell')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu categories={SellCategories} />
        </div>
      )}
      {hoveredItem === 'Premium Services' && navRefs.current[4] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[4].getBoundingClientRect().bottom,
            // left: navRefs.current[4].getBoundingClientRect().left  // Position submenu under "Buy"
            left: "20%",
            right: "20%"
          }}
          onMouseEnter={() => setHoveredItem('Premium Services')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <PremiumServices setHoveredItem={setHoveredItem} />
        </div>
      )}

      {hoveredItem === 'Relation Management' && navRefs.current[3] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[3].getBoundingClientRect().bottom,
            left: navRefs.current[3].getBoundingClientRect().left
          }}
          onMouseEnter={() => setHoveredItem('Relation Management')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu 
          categories={RelationManagementCategories}
          onItemClick={() => goTo("/relationship/management")}
          />
        </div>
      )}



      {hoveredItem === 'Plans' && navRefs.current[5] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[5].getBoundingClientRect().bottom,
            left: navRefs.current[5].getBoundingClientRect().left  // Position submenu under "Buy"
          }}
          onMouseEnter={() => setHoveredItem('Plans')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu categories={PlansCategories} onItemClick={() => setModalOpen(true)} />
        </div>
      )}
      {hoveredItem === 'Usefull Links' && navRefs.current[6] && (
        <div
          className="fixed z-50"
          style={{
            top: navRefs.current[6].getBoundingClientRect().bottom,
            left: navRefs.current[6].getBoundingClientRect().left  // Position submenu under "Buy"
          }}
          onMouseEnter={() => setHoveredItem('Usefull Links')}
          onMouseLeave={() => setHoveredItem('')}
        >
          <NavigationMenu categories={UseFullLinksCategories}  />
        </div>
      )}

      <ComingSoonModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default SubNavBar;
